import { IOrderDetailed } from '../../../types/orders';
import { IUser } from '../../../types/users';

export enum ActionTypes {
  getOrdersRequest = 'GET_ORDERS_REQUEST',
  getOrdersSuccess = 'GET_ORDERS_SUCCESS',
  getOrdersFailure = 'GET_ORDERS_FAILURE',
}

export interface IOrdersState {
  openOrders: IOrderDetailed[];
  incompleteOrders: IOrderDetailed[];
  finishedOrders: IOrderDetailed[];
}

export interface IOrdersInput {
  user: IUser;
  jwt: string;
  status: string;
  startDate?: Date | null;
}

export interface IOrdersSuccessInput {
  status: string;
  orders: IOrderDetailed[];
}

export interface IOrdersResponse {
  status: string;
  orders: IOrderDetailed[];
}

export interface IGetOrdersRequestReturn {
  type: string;
  payload: {
    input: IOrdersInput;
  };
}

export interface IGetOrdersSuccessReturn {
  type: string;
  payload: {
    input: IOrdersSuccessInput;
  };
}
